<template>
	<div :class="['dropdown', { 'is-right': isRight }]" class="is-hoverable">
		<div class="dropdown-trigger is-clickable">
			<i class="fa-solid fa-ellipsis" @click="toggleDropdown"></i>
		</div>
		<div class="dropdown-menu" v-if="isDropdownOpen">
			<div class="dropdown-content">
				<a v-for="option in options" v-if="!(option.value === 2 && line.isFired)"
				   class="dropdown-item"
				   :class="{'is-hidden-tablet': option.value === 1}"
				   @click="selectOption(option.value)">
					{{ option.label }}
				</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		options: {
			type: Array,
			required: true
		},
		line: {
			type: Object,
			required: true
		},
	},
	data() {
		return {
			isDropdownOpen: false,
			isRight: false,
		};
	},
	methods: {
		toggleDropdown() {
			this.isDropdownOpen = !this.isDropdownOpen;
			if (this.isDropdownOpen) {
				document.addEventListener('click', this.handleOutsideClick);
			} else {
				document.removeEventListener('click', this.handleOutsideClick);
			}
		},
		closeDropdown() {
			this.isDropdownOpen = false;
			document.removeEventListener('click', this.handleOutsideClick);
		},
		selectOption(selectedValue) {
			let args = {
				selectedValue: selectedValue,
				line: this.line
			};
			this.isDropdownOpen = false;
			this.$emit('selected-option', args);
			document.removeEventListener('click', this.handleOutsideClick);
		},
		updateDropdown() {
			this.isRight = window.innerWidth <= 768;
		},
		handleOutsideClick(event) {
			if (!this.$el.contains(event.target)) {
				this.closeDropdown();
			}
		},
	},
	watch: {
		isDropdownOpen(newVal) {
			this.updateDropdown();
		},
	},
	beforeUnmount() {
		document.removeEventListener('click', this.handleOutsideClick);
	},
};
</script>

<style scoped>
.dropdown-menu {
	display: block !important;
	left: unset;
	right: 0;
}

@media screen and (max-width: 768px) {
	.dropdown-menu {
		width: 100%;
	}
}
</style>
